<div class="text-center" style="margin-bottom: 20px">
  <h2 translate>components.signInModalComponent.creaCuenta</h2>
  <p translate>components.signInModalComponent.obtenAcceso</p>
  <p class="ya-tienes-cuenta">
    {{ "components.signInModalComponent.yaTienesCuenta" | translate }}
    <a (click)="openLoginModal.emit()" translate
      >components.signInModalComponent.entrar</a
    >
  </p>
</div>

<div class="content-modal">
  <button id="btn_signin_google" (click)="googleRequest?.requestAccessToken()" class="btn-sign-in">
    <i class="fab fa-google"></i>
    <span translate>components.signInModalComponent.registrarGoogle</span>
  </button>
  <button id="btn_signin_facebook" (click)="signUpWithFB.emit()" class="btn-sign-in">
    <i class="fab fa-facebook"></i>
    <span translate>components.signInModalComponent.registrarFacebook</span>
  </button>
  <button id="btn_signin_email_option" (click)="goToStep.emit(1)" class="btn-sign-in">
    <i class="far fa-envelope icon-envelope"></i>
    <span translate>components.signInModalComponent.registrarEmail</span>
  </button>
</div>

<div class="text-center" style="margin-top: 20px">
  <p class="text-thin">
    {{ "components.signInModalComponent.aceptarCondiciones" | translate }}
    <a (click)="goToLegal.emit()" translate>
      components.signInModalComponent.condiciones</a
    >
  </p>
</div>
